module.exports = __webpack_public_path__ + "static/media/strong14.1728d9f2.jpg";